// Home.js
import React from 'react';
import { Box } from '@mui/material';
import { useParams } from 'react-router-dom';
import { keyframes } from '@emotion/react';
import CompanyIntro from '../CompanyIntro';
import company from '../company.json';

const gradientAnimation = keyframes`
    0% {
        background-position: 0% 50%;
    }

    100% {
        background-position: 100% 50%;
    }
`;


function Home() {
    const { lang } = useParams();
    const code = Object.hasOwn(company, lang) ? lang : 'en';
    const text = company[code];

    return (
        <Box className="company-home">
            {/* Aquí va el logotipo */}

            {/* Contenedor del logotipo con efecto de máscara */}
            <Box
                sx={{
                    position: 'relative',
                    width: '70%',
                    maxWidth: 525,
                    minWidth: 350,
                    height: 'auto',
                    display: 'flex',
                    justifyContent: 'center',
                    '&::before': {
                        content: '""',
                        display: 'block',
                        width: '100%',
                        paddingBottom: 'calc(100% * (1))',
                        background: `linear-gradient(
                            65deg, 
                            black 10%,
                            black 50%,
                            #D1395C 53%,     
                            white 56%, 
                            #F4E051 60%,
                            #76B250 62%,
                            black 65%,
                            black 80%,       /* Tramo final regresando al negro */
                            black 100%
                        )`,
                        backgroundSize: '1000% 100%',
                        animation: `${gradientAnimation} 4.5s infinite linear`,

                        WebkitMaskImage: 'url(/resources/pintative-logo.png)',
                        WebkitMaskRepeat: 'no-repeat',
                        WebkitMaskPosition: 'center',
                        WebkitMaskSize: 'contain',

                        maskImage: 'url(/resources/pintative-logo.png)',
                        maskRepeat: 'no-repeat',
                        maskPosition: 'center',
                        maskSize: 'contain',
                    },
                }}
            />



            <header className="company-welcome">
                <h1>{text.welcome}</h1>
                <p>{text.tagline}</p>
            </header>

            <CompanyIntro lang={code} />

            <section className="company-approach" aria-labelledby="approach-title">
                <div className="company-section-heading">
                    <h2 id="approach-title">{text.approachHeading}</h2>
                    <p>{text.approachIntro}</p>
                </div>
                <div className="company-principles">
                    {text.principles.map(([title, description]) => (
                        <article className="company-principle" key={title}>
                            <h3>{title}</h3>
                            <p>{description}</p>
                        </article>
                    ))}
                </div>
                <a className="company-contact" href={`/${code}/contact/`}>{text.contact} →</a>
            </section>
        </Box>
    );
}

export default Home;
